import { logger } from '~/features/logging/logger';

import { pdPromotionStateSchema } from '../models/get-pd-promotion-state';

export async function getPdPromotionState() {
  try {
    const result = await fetch('/api/get-pd-promotion-state');
    if (result.ok) {
      return pdPromotionStateSchema.parse(await result.json());
    } else {
      throw new Error(`Error fetching Personal Discount Promotion state.`);
    }
  } catch (error) {
    logger.error('Error fetching Personal Discount Promotion state', {
      file: 'src/features/promotions/controllers/get-pd-promotion-state.ts',
      function: 'getPdPromotionState',
      error,
    });
  }
  return pdPromotionStateSchema.parse({ status: 'inactive' });
}
